import React, { Component } from 'react';
import './App.css';
import './ui/googleButtons.css'
import * as firebase from "firebase";
import config from './firebase/fire'
import Screen from './ui/screens'

export default class App extends Component {
  state = {
    loggedIn: false,
    isLoading: true
  }

  componentWillMount() {
    firebase.initializeApp(config);
    if ("Notification" in window){
      Notification.requestPermission()
    }
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          loggedIn: true,
          isLoading: false
        })
      } else {
        this.setState({
          loggedIn: false,
          isLoading: false
        })
      }
    })
  }

  render() {
    const { isLoading } = this.state
    return (
      <div className="App">
        {
          isLoading
            ? <div> loading </div>
            : <Screen {...this.state} />
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App.js